export default "assets/images/logo-vinsdenantes-footer-ce896e21.png";